export const onRemoveAnswer = (state, action) => {
  return {
    ...state,
    answer: state.answer.filter(answer => answer.id !== action.id)
  };
};

export const onChangeAnswer = (state, action) => {
  const exists = state.answer.find(a => a.id === action.answer.id);

  if (exists) {
    return {
      ...state,
      answer: state.answer.map(answer => {
        return answer.id !== action.answer.id ? answer : action.answer;
      })
    };
  }

  return {
    ...state,
    answer: action.multiChoice
      ? [...state.answer, action.answer]
      : [action.answer]
  };
};
